<template>
  <div>
    <v-divider></v-divider>

    <v-list
      subheader
      two-line
    >
      <v-subheader>{{ inputName }}</v-subheader>

      <v-list-item-group
        multiple
        active-class=""
        class="px-6"
      >
        <image-file-input-viewer
          class="mt-2"
          maxHeight="150"
          label="Section BG image"
          v-model="sectionData.bg_thumbnail"
          :clearable="true"
        />

        <v-checkbox
          label="Hide BG Image"
          v-show="sectionData.bg_thumbnail"
          v-model="sectionData.hide_bg_image"
        />
        <color-picker
          label="Section BG color"
          v-bind:color.sync="sectionData.bg_color"
        />
      </v-list-item-group>
    </v-list>

    <v-divider></v-divider>

    <v-list
      flat
      subheader
    >
      <v-subheader>Content</v-subheader>

      <v-list-item-group
        multiple
        active-class=""
        class="px-6"
      >

        <v-expansion-panels
          accordion
          class="mb-5"
        >
          <v-expansion-panel
            :key="i"
            v-for="(item, i) in sectionData[sectionData.type]"
          >
            <v-expansion-panel-header>{{ inputName }} {{ i + 1 }} </v-expansion-panel-header>
            <v-expansion-panel-content class="pb-4">
              <v-card
                shaped
                class="withdrawal-options mb-5"
              >
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <image-file-input-viewer
                        maxHeight="150"
                        class="mt-2"
                        label="Image"
                        v-model="sectionData[sectionData.type][i].thumbnail"
                        :clearable="true"
                        acceptedImages=".jpg, .jpeg, .png, .svg, .gif"
                        v-bind:removeImage.sync="sectionData[sectionData.type][i].thumbnail_deleted"
                      />

                      <v-checkbox
                        label="Remove Image"
                        v-show="sectionData[sectionData.type][i].thumbnail && sectionData[sectionData.type][i].thumbnail.id"
                        v-model="sectionData[sectionData.type][i].thumbnail_deleted"
                      />

                      <image-file-input-viewer
                        maxHeight="150"
                        label="Mobile Image"
                        v-model="sectionData[sectionData.type][i].thumbnail_mobile"
                        :clearable="true"
                        acceptedImages=".jpg, .jpeg, .png, .svg, .gif"
                        v-bind:removeImage.sync="sectionData[sectionData.type][i].mobile_thumbnail_deleted"
                      />

                      <v-checkbox
                        label="Remove Mobile Image"
                        v-show="sectionData[sectionData.type][i].thumbnail_mobile && sectionData[sectionData.type][i].thumbnail_mobile.id"
                        v-model="sectionData[sectionData.type][i].mobile_thumbnail_deleted"
                      />

                      <v-text-field
                        v-model="sectionData[sectionData.type][i].url"
                        outlined
                        label="URL"
                        dense
                      />

                      <v-text-field
                        v-model="sectionData[sectionData.type][i].image_alt_text"
                        outlined
                        label="Image alt text"
                        dense
                      />

                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="removeFAQ(i)"
                    color="red"
                    class="mr-3"
                    small
                    icon
                  >
                    <v-icon
                      small
                      color="red"
                    >mdi-trash-can-outline</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-btn
          v-if="sectionData[sectionData.type].length < 3"
          @click="addFAQ"
          class="green accent-4 white--text text-caption font-weight-bold header-btns"
        >Add Item
        </v-btn>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
import ImageFileInputViewer from '@/components/ImageFileInputViewer'
import ColorPicker from '@/components/ColorPicker'

export default {
  name: 'PageGallery',
  components: {
    ImageFileInputViewer,
    ColorPicker
  },
  props: {
    sectionData: {
      type: Object,
      default () {
        return null
      }
    },
    inputName: {
      type: String,
      default: ''
    },
    removedSections: {
      type: Array,
      default () {
        return []
      }
    }
  },
  methods: {
    addFAQ () {
      this.sectionData[this.sectionData.type].push(
        {
          title: null,
          description: null,
          thumbnail: null,
          thumbnail_mobile: null
        }
      )
    },
    removeFAQ (i) {
      if (this.sectionData[this.sectionData.type][i].id) {
        this.removedSections.push({
          type: this.sectionData.type,
          id: this.sectionData[this.sectionData.type][i].id
        })
      }
      this.sectionData[this.sectionData.type].splice(i, 1)
    },
    setDefaultColors () {
      if (!this.sectionData.bg_color) {
        this.sectionData.bg_color = '#3F51B5'
      }
    }
  },
  created () {
    // this.setDefaultColors()
  }
}
</script>

<style scoped>
.header-btns {
  color: #df4661;
  cursor: pointer;
}
.withdrawal-options {
  margin-top: 20px;
}
</style>
